import * as React from 'react';
import Helmet from '../../../commonComponents/Helmet';
import { clearPublicClientLocalStorage } from '../../../core/localStorage';
import PublicAutoLogoutLayout, {
	PublicHeaderLogo,
	PublicLogoWrapper,
	SubTitleParagraph,
	TitleParagraph
} from './common/PublicLayout';
import { useRequireProgress } from './common/PublicProgressContext';
import {
	ctxTermsAccepted,
	ctxClientTypeSelected,
	ctxClientBasicInfoCompleted,
	ctxClientProfileReviewed
} from './common/publicConstants';
import PublicFormButtons from './common/PublicFormButtons';
import { kellyPartnersWebsiteUrl } from '../../../core/constants';
import checkSvg from '../../../images/check.svg';

const PublicProfileCompletionPage = () => {
	// Ensure the user has completed all steps to access this page.
	useRequireProgress([ctxTermsAccepted, ctxClientTypeSelected, ctxClientBasicInfoCompleted, ctxClientProfileReviewed]);
	clearPublicClientLocalStorage();

	const handleContinueButtonClick = () => {
		window.location.href = kellyPartnersWebsiteUrl;
	};

	return (
		<PublicAutoLogoutLayout>
			<Helmet>
				<title>Profile Completion | Prospective Client</title>
			</Helmet>
			<PublicLogoWrapper>
				<PublicHeaderLogo src={checkSvg} alt="Kelly+Partners Client" />
			</PublicLogoWrapper>
			<TitleParagraph $bold>Application Submitted</TitleParagraph>
			<SubTitleParagraph>
				Thank you for choosing Kelly+Partners Accountants.
				<br />
				Your assigned Partner will be in touch within the next 48 hours to discuss the next steps.
			</SubTitleParagraph>
			<PublicFormButtons continueButtonText="Visit our website" onContinueButtonClick={handleContinueButtonClick} />
		</PublicAutoLogoutLayout>
	);
};

export default PublicProfileCompletionPage;
